const dateFmt = new Intl.DateTimeFormat('fr-FR', { day: '2-digit', month: '2-digit', year: 'numeric' });
const dateTimeFmt = new Intl.DateTimeFormat('fr-FR', { dateStyle: 'short', timeStyle: 'short' });
const numberFmt = new Intl.NumberFormat('fr-FR');

export const formatDate = (iso: string | null | undefined): string => (iso ? dateFmt.format(new Date(iso)) : '—');

export const formatDateTime = (iso: string | null | undefined): string => (iso ? dateTimeFmt.format(new Date(iso)) : '—');

export const formatNumber = (n: number): string => numberFmt.format(n);
